import React, { useEffect } from 'react'
import useCurrentUserId from '../../hooks/useCurrentUserId'
import { BookingListItemProps } from './booking_list_item'
import { usePaginatedList } from '../../hooks/usePaginatedList'
import { IBooking } from '../../apilibrary/types/booking'
import { StudioService, UserService } from '../../apilibrary'
import BookingList from './booking_list'
import Box from '../../components/box'
import Button from '../../components/button'
import Typography from '../../components/typography'

const BookingRequestedByMeList: React.FC = () => {
  const userId = useCurrentUserId() as string
  const [bookingsImHostingListItemProps, setBookingsImHostingListItemProps] = React.useState<BookingListItemProps[]>([])
  const {
    items: bookings,
    hasMore,
    loading: loadingFetchBookings,
    fetchNextPage: fetchNextPageBookingsImHosting
  } = usePaginatedList<IBooking>({
    fetchFunction: async (pagination) => {
      const response = await UserService.getRequestedBookingByUserId(userId, pagination)
      return response
    }
  })

  React.useEffect(() => {
    const fetchBookings = async (): Promise<void> => {
      const fetchedBookings = await UserService.getRequestedBookingByUserId(userId)
      console.log(fetchedBookings)
    }

    void fetchBookings()
  }, [userId])

  useEffect(() => {
    const handlePayBooking = async (bookingId: string): Promise<void> => {
      const url = await StudioService.getBookingPaymentUrl(bookingId)
      window.open(url, '_blank')
    }

    const transformBookings = async (): Promise<void> => {
      const newListItems = await Promise.all(bookings.map(async (booking) => {
        const coverImageUrl = await booking.studio.coverPicture.getPublicUrl()
        return {
          studioId: booking.studio.id,
          studioName: booking.studio.title,
          isProvider: false,
          location: booking.studio.location,
          studioImageUrl: coverImageUrl,
          providedBy: `${booking.host.firstName ?? 'Unnamed'} ${booking.host.lastName ?? 'User'}`,
          serviceStartTime: booking.startTime,
          serviceEndTime: booking.endTime,
          handlePayBooking: async () => { await handlePayBooking(booking.id); },
          status: booking.status
        }
      }))
      setBookingsImHostingListItemProps(newListItems)
    }

    void transformBookings()
  }, [bookings])

  return (
    <Box>
      {!loadingFetchBookings && bookings.length === 0 && (
        <Typography color={'secondary'} mt={4} textAlign={'center'} fontSize={'1.5rem'} fontWeight={'bold'}>
          You have no bookings yet.
        </Typography>
      )}
      <BookingList bookings={bookingsImHostingListItemProps} />
      { hasMore && (
        <Button disabled={loadingFetchBookings} sx={{
          display: 'block',
          ml: 'auto'
        }} color='secondary' variant='outlined' onClick={fetchNextPageBookingsImHosting}>Load More</Button>
      )}
    </Box>
  )
}

export default BookingRequestedByMeList
